export default __webpack_public_path__ + "static/media/blog-img76.3d3240b5.jpg";